import React from 'react';

const Testimonials = () => {
    return (
        <section className="feature-section">
        <div className="container">
            <h2 className="section-title center">CUSTOMER SUCCESS</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', marginTop: '3rem' }}>
                
                <div className="gh-panel" style={{ padding: '2rem', borderLeft: '4px solid var(--gh-link)' }}>
                    <p style={{ color: 'var(--gh-text-muted)', fontStyle: 'italic', margin: 0 }}>
                        "PassiveGuard cut our incident response time in half and uncovered threats we didn't know we were missing. It's the only tool my team actually enjoys using."
                    </p>
                </div>

                <div className="gh-panel" style={{ padding: '2rem', borderLeft: '4px solid var(--gh-border-active)' }}>
                    <p style={{ color: 'var(--gh-text-muted)', fontStyle: 'italic', margin: 0 }}>
                        "The AI correlation is magic. We went from drowning in false positives to only seeing what matters. The board loves the executive reports."
                    </p>
                </div>

            </div>
        </div>
        </section>
    );
};

export default Testimonials;
